export default "__VITE_ASSET__BvJ5KSsJ__"